import {
  EKwikUIInputRadioOrientation,
  EKwikUIInputRadioSize,
  VKwikUIInputRadioOrientation,
  VKwikUIInputRadioSize
} from "./input-radio.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isString = (x: string) => typeof x === "string";

  const methods = {
    disabled: isBoolean,
    focus: isBoolean,
    formControlName: isString,
    id: isString,
    invalid: isBoolean,
    items: Array.isArray,
    label: isString,
    orientation: (x: EKwikUIInputRadioOrientation) =>
      VKwikUIInputRadioOrientation.includes(x),
    placeholder: isString,
    size: (x: EKwikUIInputRadioSize) => VKwikUIInputRadioSize.includes(x)
  };

  return methods[key] && methods[key](value);
};
